module.exports = __webpack_public_path__ + "img/yijian_zhhongji-11.d8faf5f3.png";